import { useMemo } from 'react';
import { isLocalhost } from '../utils/urls';

const RESERVED_SUBDOMAINS = new Set([
  // Infrastructure subdomains
  'www', 'api', 'media', 'auth', 'app', 'cdn', 'static', 'assets',
  'images', 'files', 'uploads', 'download', 'downloads',
  // Auth-related
  'login', 'signin', 'signup', 'register', 'logout', 'oauth', 'account', 'accounts',
  // Admin & support
  'admin', 'administrator', 'help', 'support', 'status', 'docs', 'documentation',
  // Developer
  'developer', 'developers', 'dev', 'api-docs',
  // Company/marketing
  'blog', 'about', 'contact', 'legal', 'privacy', 'terms', 'security',
  'careers', 'jobs', 'press', 'news', 'brand',
  // Technical
  'graphql', 'rest', 'ws', 'wss', 'mail', 'smtp', 'ftp', 'ssh',
  // Environments
  'staging', 'test', 'prod', 'production', 'beta', 'alpha', 'demo', 'sandbox',
  // Sensitive/system
  'root', 'system', 'null', 'undefined', 'anonymous', 'unknown',
  // App features
  'dashboard', 'settings', 'profile', 'profiles', 'user', 'users',
  'commit', 'commits', 'feed', 'explore', 'search', 'notifications', 'invite',
]);
const BASE_DOMAIN = 'commit.you';

/**
 * Extracts the subdomain from the current URL.
 * Returns null if on the main domain, localhost, or a reserved subdomain.
 */
export function useSubdomain(): string | null {
  return useMemo(() => {
    // Local development - no subdomain routing
    if (isLocalhost) {
      return null;
    }

    const hostname = window.location.hostname;

    // Check if on a subdomain of commit.you
    if (hostname.endsWith(`.${BASE_DOMAIN}`)) {
      const subdomain = hostname.replace(`.${BASE_DOMAIN}`, '');

      // Ignore reserved subdomains
      if (RESERVED_SUBDOMAINS.has(subdomain.toLowerCase())) {
        return null;
      }

      return subdomain;
    }

    return null;
  }, []);
}

